/** Delade hjälpkonstanter och -funktioner för UI-komponenter. */

export const GREEN_PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='500'%3E%3Crect width='100%25' height='100%25' fill='%231e3d1e'/%3E%3C/svg%3E";

/** Formatterar ett ISO-datumsträng till sv-SE kort form. */
export function fmtD(s: string): string {
  if (!s) return '';
  return new Date(s).toLocaleDateString('sv-SE', { day: 'numeric', month: 'short', year: 'numeric' });
}

/** Returnerar färg baserat på andel platser kvar. */
export function spotsColor(available: number, total: number, successColor: string, dangerColor: string): string {
  const r = available / total;
  if (r <= 0) return dangerColor;
  if (r <= 0.25) return '#e67e22';
  return successColor;
}

/** Formaterar ett tal som SEK. */
export function fmtSEK(n: number): string {
  return n.toLocaleString('sv-SE');
}

/** Jakttyps-filter för marketplace. */
export const HUNT_FILTER_LABELS: Record<string, string> = {
  Alla: 'Alla jakter',
  älg: 'Älg',
  dovhjort: 'Dovhjort',
  kronhjort: 'Kronhjort',
  rådjur: 'Rådjur',
  vildsvin: 'Vildsvin',
  fasan: 'Fasan',
  kanadagås: 'Kanadagås',
};
export const HUNT_FILTER_KEYS = Object.keys(HUNT_FILTER_LABELS);
